// Configuração do site baseada em variáveis de ambiente
// IMPORTANTE: Os valores padrão são do alphacanalizacoes.pt
// Só muda para alphadesentupimentos.pt se VITE_SITE_ID === 'desentupimentos'
// Só muda para alphacanalizacoesporto.pt se VITE_SITE_ID === 'porto'

// Se VITE_SITE_ID não estiver definida, usa 'canalizacoes' (alphacanalizacoes.pt)
const siteId = import.meta.env.VITE_SITE_ID || 'eletrodomesticos';

export interface SiteConfig {
  name: string;
  domain: string;
  email: string;
  phone: string;
  phoneDisplay: string;
  address: {
    street: string;
    city: string;
    postalCode: string;
    country: string;
  };
  description: string;
  descriptionShort: string;
  metaTitle?: string;
  metaDescription?: string;
  logoAlt: string;
  aboutUs: string;
  web3formsKey?: string;
}

const configs: Record<string, SiteConfig> = {
  // Configuração padrão do alphacanalizacoes.pt (usado se VITE_SITE_ID não estiver definida)
  canalizacoes: {
    name: 'ALPHA CANALIZAÇÕES',
    domain: 'alphacanalizacoes.pt',
    email: 'alphaservices.pt@gmail.com',
    phone: '+351934631520',
    phoneDisplay: '934 631 520',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Especialistas em serviços de canalização em Lisboa. Reparação urgente, desentupimentos, instalação e manutenção. Técnicos locais, atendimento 24h e orçamentos gratuitos.',
    descriptionShort: 'Especialistas em serviços de canalização em Lisboa',
    logoAlt: 'ALPHA CANALIZAÇÕES',
    aboutUs: 'A ALPHA CANALIZAÇÕES é uma empresa especializada em serviços de canalização em Lisboa'
  },
  // Configuração do alphadesentupimentos.pt (só usado se VITE_SITE_ID === 'desentupimentos')
  desentupimentos: {
    name: 'ALPHA DESENTUPIMENTOS',
    domain: 'alphadesentupimentos.pt',
    email: 'alphaservices.pt@gmail.com', // Mesmo email dos dois sites
    phone: '+351934631520', // Mesmo telefone dos dois sites
    phoneDisplay: '934 631 520',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Especialistas em desentupimentos urgentes 24h em Lisboa. Desentupimento de esgotos, sanitas, pias e colunas prediais. Hidrojato e vídeo inspeção. Técnicos locais, atendimento 24h e orçamentos gratuitos.',
    descriptionShort: 'Especialistas em desentupimentos urgentes 24h em Lisboa',
    logoAlt: 'ALPHA DESENTUPIMENTOS',
    aboutUs: 'A ALPHA DESENTUPIMENTOS é uma empresa especializada em desentupimentos em Lisboa'
  },
  // Configuração do alphacanalizacoesporto.pt (só usado se VITE_SITE_ID === 'porto')
  porto: {
    name: 'ALPHA CANALIZAÇÕES',
    domain: 'alphacanalizacoesporto.pt',
    email: 'alphaservices.pt@gmail.com',
    phone: '+351934631520',
    phoneDisplay: '934 631 520',
    address: {
      street: 'Rua da Alegria, 29',
      city: 'Porto',
      postalCode: '4000-041',
      country: 'PT'
    },
    description: 'Especialistas em serviços de canalização no Porto. Reparação urgente, desentupimentos, instalação e manutenção. Técnicos locais, atendimento 24h e orçamentos gratuitos.',
    descriptionShort: 'Especialistas em serviços de canalização no Porto',
    logoAlt: 'ALPHA CANALIZAÇÕES',
    aboutUs: 'A ALPHA CANALIZAÇÕES é uma empresa especializada em serviços de canalização no Porto'
  },
  // Configuração do alphaeletrica.pt (só usado se VITE_SITE_ID === 'eletrica')
  eletrica: {
    name: 'ALPHA ELÉTRICA',
    domain: 'alphaeletrica.pt',
    email: 'Alphaeletricapt@gmail.com',
    phone: '+351933537339',
    phoneDisplay: '933 537 339',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Especialistas em serviços elétricos em Lisboa. Instalações, reparações, quadros elétricos, certificações e manutenção. Eletricistas certificados, atendimento 24h e orçamentos gratuitos.',
    descriptionShort: 'Especialistas em serviços elétricos em Lisboa',
    logoAlt: 'ALPHA ELÉTRICA',
    aboutUs: 'A ALPHA ELÉTRICA é uma empresa especializada em serviços elétricos em Lisboa'
  },
  // Configuração do alphaeletric.pt (só usado se VITE_SITE_ID === 'eletric')
  eletric: {
    name: 'ALPHA ELETRIC',
    domain: 'alphaeletric.pt',
    email: 'Alphaeletricapt@gmail.com',
    phone: '+351934631520',
    phoneDisplay: '934 631 520',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Especialistas em serviços elétricos em Lisboa. Instalações, reparações, quadros elétricos, certificações e manutenção. Eletricistas certificados, atendimento 24h e orçamentos gratuitos.',
    descriptionShort: 'Especialistas em serviços elétricos em Lisboa',
    logoAlt: 'ALPHA ELETRIC',
    aboutUs: 'A ALPHA ELETRIC é uma empresa especializada em serviços elétricos em Lisboa'
  },
  // Configuração do alphaservices.pt (só usado se VITE_SITE_ID === 'eletrodomesticos')
  eletrodomesticos: {
    name: 'ALPHA SERVICES',
    domain: 'alphaservices.pt',
    email: 'alphaservices.pt@gmail.com',
    phone: '+351934631520',
    phoneDisplay: '934 631 520',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Especialistas em instalação de eletrodomésticos em Lisboa. Placas, fornos, fogões, microondas, máquinas de lavar e frigoríficos. Instalação profissional com garantia.',
    descriptionShort: 'Especialistas em instalação de eletrodomésticos em Lisboa',
    metaTitle: 'ALPHA SERVICES - Instalação de Eletrodomésticos em Lisboa',
    metaDescription: 'Especialistas em instalação profissional de eletrodomésticos em Lisboa. Placas, fornos, máquinas de lavar, frigoríficos e termoacumuladores. Preços fixos e garantia incluída.',
    logoAlt: 'ALPHA SERVICES',
    aboutUs: 'A ALPHA SERVICES é uma empresa especializada em instalação de eletrodomésticos em Lisboa'
  },
  // Configuração do alphaclimatizacao.pt (só usado se VITE_SITE_ID === 'climatizacao')
  climatizacao: {
    name: 'ALPHA CLIMATIZAÇÃO',
    domain: 'alphaclimatizacao.pt',
    email: 'alphaservices.pt@gmail.com',
    phone: '+351934631520',
    phoneDisplay: '934 631 520',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Especialistas em ar condicionado em Lisboa. Manutenção, instalação, venda de equipamentos, pré-instalação para obra e peças de reposição. Técnicos certificados, garantia e orçamento gratuito.',
    descriptionShort: 'Especialistas em ar condicionado em Lisboa',
    metaTitle: 'ALPHA CLIMATIZAÇÃO - Ar Condicionado em Lisboa | Instalação e Manutenção',
    metaDescription: 'Manutenção, instalação e venda de ar condicionado em Lisboa. Pré-instalação para obra e peças de reposição. Técnicos certificados, garantia e orçamento gratuito.',
    logoAlt: 'ALPHA CLIMATIZAÇÃO',
    aboutUs: 'A ALPHA CLIMATIZAÇÃO é uma empresa especializada em ar condicionado e climatização em Lisboa'
  },
  // Configuração do alphaclean.pt (só usado se VITE_SITE_ID === 'clean' ou 'limpeza')
  clean: {
    name: 'ALPHA CLEAN',
    domain: 'alphaclean.pt',
    email: 'alphaservices.pt@gmail.com',
    phone: '+351937480742',
    phoneDisplay: '937 480 742',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Empresa de limpeza profissional em Lisboa. Condomínios, pós-obra, escritórios, residencial, alojamento local, restaurantes e lojas comerciais. Equipas fixas e orçamento gratuito.',
    descriptionShort: 'Empresa de limpeza profissional em Lisboa',
    metaTitle: 'ALPHA CLEAN - Empresa de Limpeza em Lisboa | Condomínios, Escritórios e Pós-Obra',
    metaDescription: 'Empresa de limpeza profissional em Lisboa. Condomínios, pós-obra, escritórios, limpeza doméstica, alojamento local, restaurantes e lojas. Equipas fixas e orçamento gratuito.',
    logoAlt: 'ALPHA CLEAN',
    aboutUs: 'A ALPHA CLEAN é uma empresa especializada em serviços de limpeza profissional em Lisboa'
  },
  limpeza: {
    name: 'ALPHA CLEAN',
    domain: 'alphaclean.pt',
    email: 'alphaservices.pt@gmail.com',
    phone: '+351937480742',
    phoneDisplay: '937 480 742',
    address: {
      street: 'Rua Damaceno, 10 1º andar',
      city: 'Lisboa',
      postalCode: '1900-396',
      country: 'PT'
    },
    description: 'Empresa de limpeza profissional em Lisboa. Condomínios, pós-obra, escritórios, residencial, alojamento local, restaurantes e lojas comerciais. Equipas fixas e orçamento gratuito.',
    descriptionShort: 'Empresa de limpeza profissional em Lisboa',
    metaTitle: 'ALPHA CLEAN - Empresa de Limpeza em Lisboa | Condomínios, Escritórios e Pós-Obra',
    metaDescription: 'Empresa de limpeza profissional em Lisboa. Condomínios, pós-obra, escritórios, limpeza doméstica, alojamento local, restaurantes e lojas. Equipas fixas e orçamento gratuito.',
    logoAlt: 'ALPHA CLEAN',
    aboutUs: 'A ALPHA CLEAN é uma empresa especializada em serviços de limpeza profissional em Lisboa'
  }
};

// Se siteId não existir ou for inválido, sempre usa 'canalizacoes' (alphacanalizacoes.pt)
// Última atualização: 2026-05-16 18:22
export const siteConfig = configs[siteId] || configs.canalizacoes;

